/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ApplyIdClick,
  ApplyIdClickSuccess,
  ChangeHeight,
  ChangeHeightSuccess,
  ClosePopupAction,
  ClosePopupActionSuccess,
  ValidateSelection,
  ValidateSelectionSuccess,
} from './apply-id-actions';
import { concatMap, map } from 'rxjs/operators';
import { BackendService } from '../../../../../utils/src/lib/sysque-backend/backend.service';
import { from, of } from 'rxjs';

@Injectable()
export class ApplyIdEffects {
  constructor(
    private readonly actions$: Actions, 
    private backendService: BackendService
  ) {}

  changeDialogDimensions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ChangeHeight),
      concatMap((action) => {
        this.backendService.changeDialogHeight(action.height);
        return from([ChangeHeightSuccess({ response: 'OK' })]);
      })
    );
  });

  validateSelection$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ValidateSelection),
      concatMap(() =>
        this.backendService.validateSelection().pipe(
          map((data) => data && ValidateSelectionSuccess({ response: data }))
        )
      )
    );
  });

  applyButtonClick$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApplyIdClick),
      concatMap((action) => {
        this.backendService.applyButtonClick(action.id);
        return from([ApplyIdClickSuccess({ response: 'OK' })]);
      })
    );
  });

  closePopupAction$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ClosePopupAction),
      concatMap(() => {
        this.backendService.sendClosePopupAction();
        return from([ClosePopupActionSuccess({ response: 'OK' })]);
      })
    );
  });
}
